var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"font-12 fst-italic text-danger"},[_vm._v(_vm._s(_vm.message))])
}
var staticRenderFns = []

export { render, staticRenderFns }